import React, {CSSProperties} from "react";
import {Text} from "atmosfair-ui";
import './styles.css'
import {AllActivityTypes} from "../../../types-enums/activity";
import {useTranslation} from "react-i18next";
import {generateWhyDroppableDisabledString} from "./common";


interface DroppableDisabledProps {
    activity: AllActivityTypes,
    style?: CSSProperties,
    day?: number | null,
    journeyDurationInDays?: number
}

const DroppableDisabled = ({
                               style,
                               activity,
                               day,
                               journeyDurationInDays,
                           }: DroppableDisabledProps) => {
    const {i18n} = useTranslation()
    return <div style={style} className={'droppable-disabled-container'}>
        <Text color={"white"}>{generateWhyDroppableDisabledString(
            activity,
            day,
            i18n,
            journeyDurationInDays
        )}</Text>
    </div>
}

export default DroppableDisabled